<section fxLayout="row" class="h-100">
    <section fxFlex="1 1 76%" class="sen-body-max-width" id="roof_structure_canvas_container">
        <!-- <ng-container *ngIf="!trapezDirect"> -->
        <div id="roofContainer">
            <div id="scrollCanvas"></div>
            <div id="canvas_stage_for_roof"></div>
        </div>
        <!-- </ng-container> -->
        <div *ngIf="trapezDirect" class="h-100" fxLayout="row" fxLayoutAlign="center center">
            <img src="{{imagePath.TRAPEZ_SHEET}}">
        </div>
    </section>
    <section fxLayout="column" class="sen-tool-bar px-3 sen-light-blue-bg"
        [ngClass]="{'sen-roof-rafter' : rbRafter, 'sen-roof-purlin' : rbPurlin, 'sen-trapez-criss-cross' : trapezCrisCross}">
        <div fxFlex="1 1 auto">
            <h2 class="pt-2">{{translate.getLng('ROOF_STRUCTURE')}}</h2>
            <div fxLayout="row" *ngIf="!trapezDirect">
                <label>{{translate.getLng('BEAM_TYPE')}}</label>
                <button mat-raised-button disableRipple class="sen-no-pointer mx-auto position-relative"><span
                        class="sen-rafter-text">{{translate.getLng('RAFTER')}}</span>
                    <span class="ml-5 sen-purlin-text">{{translate.getLng('PURLIN')}}</span>
                    <button color="primary" disableRipple mat-raised-button
                        class="w-50 position-absolute sen-bg-slider sen-no-pointer">
                        &nbsp;</button>
                </button>
            </div>
            <hr class="border-white">
            <ng-container *ngIf="!trapezDirect">
                <sen-app-mount-purlin (emitbSuccess)="bSuccess = $event" [trapezCrisCross]="trapezCrisCross"
                    [vbPurlinAdditional]="vbPurlinAdditional" *ngIf="rbPurlin"></sen-app-mount-purlin>
                <sen-app-mount-rafter (emitbSuccess)="bSuccess = $event" [hbRoofHook]="hbRoofHook" *ngIf="rbRafter">
                </sen-app-mount-rafter>
            </ng-container>
            <sen-app-trapez-direct (formValid)="bSuccess = !$event" *ngIf="trapezDirect"></sen-app-trapez-direct>
            <mat-error *ngIf="bSuccess" class="sen-distance-error sen-fs10">{{translate.getLng('BEAM_DIST_LAST')}}
                {{translate.getLng('MUST_BE_SMALLER')}}
                {{rbPurlin ? translate.getLng('PURLIN_DISTANCE') : translate.getLng('RAFTER_DISTANCE')}},
                {{translate.getLng('ERROR')}}</mat-error>
        </div>
        <div class="my-2" fxLayout="row" fxLayoutAlign="space-evenly center">
            <button mat-raised-button class="px-5 py-2" color="primary"
                [routerLink]="[prevPath]">{{translate.getLng('PREV')}}</button>
            <button (click)="goToNext()" mat-raised-button class="px-5 py-2"
                color="primary">{{translate.getLng('NEXT')}}</button>
        </div>
    </section>
</section>